module.exports = __webpack_public_path__ + "imgs/facebook-color.24b57eb6684d6bd039c0a64921499472.svg";